import { render, staticRenderFns } from "./subdiariocobranzas.vue?vue&type=template&id=40854475"
import script from "./subdiariocobranzas.vue?vue&type=script&lang=js"
export * from "./subdiariocobranzas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports